import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes, Navigate } from "react-router-dom";

import { ALLOWED_ORGS_FOR_PAYOUT } from "@/constants";
import GamingOrders from "@/modules/order/gaming/GamingOrders";
import SendMoney from "@/modules/send-money/SendMoney";
import IndividualPayment from "@/modules/send-money/individual-payments/IndividualPayment";

import SettlementDashboard from "../modules/balances/settlements/SettlementDashboard";
import PayinSettlement from "../modules/balances/settlements/payin/PayinSettlement";
import OrderDashboard from "../modules/order/OrderDashboard";
import PayinOrderSummary from "../modules/order/payin/PayinOrderSummary";
import PayinOrders from "../modules/order/payin/PayinOrders";
import PayoutOrderSummary from "../modules/order/payout/PayoutOrderSummary";
import PayoutOrdersV2 from "../modules/order/payout/PayoutOrdersV2";
import PrefundOrders from "../modules/order/prefund/PrefundOrders";
import RampOrderV2 from "../modules/order/ramp/RampOrdersV2";
import Settings from "../modules/settings/Settings";
import Users from "../modules/users";
// import ProfileBadge from "../components/nav/ProfileBadge";

const DefaultRoutes = (props) => {
  const { PageLayout, loggedInOrgId } = props;
  return (
    <div style={{ marginLeft: "252px" }}>
      <div style={{ marginRight: "10px" }}>
        <Routes>
          <Route path="*" element={<Navigate to="/order" />} />
          <Route
            path="/order"
            element={
              <PageLayout title={""}>
                <OrderDashboard />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/order/pay-in-order"
            element={
              <PageLayout title={"PAYOUT (FIAT TO STABLECOIN)"}>
                <PayinOrders />
              </PageLayout>
            }
          ></Route>
          <Route
            exact
            path="/order/pay-out-order"
            element={
              <PageLayout title={"PAYOUT (STABLECOIN TO FIAT)"}>
                <PayoutOrdersV2 />
              </PageLayout>
            }
          ></Route>
          <Route
            exact
            path="/order/prefund-order"
            element={
              <PageLayout title={"PREFUND"}>
                <PrefundOrders />
              </PageLayout>
            }
          ></Route>
          <Route
            exact
            path="/order/onramp-order"
            element={
              <PageLayout title={"On-Ramp"}>
                <RampOrderV2 />
              </PageLayout>
            }
          ></Route>
          <Route
            exact
            path="/order/offramp-order"
            element={
              <PageLayout title={"Off-Ramp"}>
                <RampOrderV2 />
              </PageLayout>
            }
          ></Route>
          <Route
            exact
            path="/order/gaming-order"
            element={
              <PageLayout title={"Gaming"}>
                <GamingOrders />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/order/pay-in-order/:orderId"
            element={
              <PageLayout title={"PayIn Order Summary"}>
                <PayinOrderSummary />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/order/pay-out-order/:orderId"
            element={
              <PageLayout title={"PayOut Order Summary"}>
                <PayoutOrderSummary />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/balances/settlement"
            element={
              <PageLayout title={"Balances"}>
                <SettlementDashboard />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/balances/settlement/payin"
            element={
              <PageLayout title={"Collection Balances (FIAT TO STABLECOIN)"}>
                <PayinSettlement />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/users"
            element={
              <PageLayout title={"Users"}>
                <Users />
              </PageLayout>
            }
          ></Route>
          <Route
            path="/settings"
            element={
              <PageLayout title={"Settings"}>
                <Settings />
              </PageLayout>
            }
          ></Route>

          {ALLOWED_ORGS_FOR_PAYOUT.includes(loggedInOrgId) && (
            <>
              <Route
                path="/settlements"
                element={
                  <PageLayout>
                    <IndividualPayment />
                  </PageLayout>
                }
              ></Route>
            </>
          )}
        </Routes>
      </div>
    </div>
  );
};

const RouteSelector = (props) => {
  const { PageLayout } = props;
  const loggedInOrgId = useSelector((state) => state?.login?.orgDetails?.orgId || "");

  return <DefaultRoutes PageLayout={PageLayout} loggedInOrgId={loggedInOrgId} />;
};

export default RouteSelector;
